import { polymorphicFactory, Box, Typography } from '@kohler-dsm-library/kohler-core';
import { ArrowRightBoldIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import classes from './OverlayMenuItem.module.css.mjs';

const OverlayMenuItem = polymorphicFactory(
  (props, ref) => {
    const { className, title, showArrow = true, component = "button", ...rest } = props;
    return /* @__PURE__ */ React.createElement(
      Box,
      {
        ref,
        className: clsx(className, "kohler-overlay-menu-item", classes.overlayMenuItem),
        component,
        type: component === "button" ? "button" : void 0,
        textColor: "var(--content-primary)",
        ...rest
      },
      /* @__PURE__ */ React.createElement(Typography, { component: "span", size: "navigation-l", textColor: "var(--content-primary)" }, title),
      " ",
      showArrow && /* @__PURE__ */ React.createElement(ArrowRightBoldIcon, { size: "xSmall", withBoundingBox: false })
    );
  }
);

export { OverlayMenuItem };
